import { useQuery } from '@tanstack/react-query';
import recoveryMessagesService from 'v2/services/recoveryMessages';

export function useListProductsSales() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['productsSales'],
    queryFn: () => recoveryMessagesService.listProductsSales(),
    select: response => (Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : []),
    staleTime: 5 * 60 * 1000
  });

  return { data: data ?? [], isLoading, error };
}
